// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LxKar","colMin":"styles_colMin__3Gi3Q"};